(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["palm-life-black-friday"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function init(root) {
    if (!root || root.__plbf) return;
    root.__plbf = true;

    // Countdown
    var els = {};
    root.querySelectorAll('[data-cd]').forEach(function (e) { els[e.dataset.cd] = e; });
    var target = Date.parse(root.dataset.end || '');
    if (els.d && !isNaN(target)) {
      var tick = function () {
        var s = Math.max(0, Math.floor((target - Date.now()) / 1000));
        var d = Math.floor(s / 86400); s -= d * 86400;
        var h = Math.floor(s / 3600); s -= h * 3600;
        var m = Math.floor(s / 60); s -= m * 60;
        els.d.textContent = pad(d); els.h.textContent = pad(h);
        els.m.textContent = pad(m); els.s.textContent = pad(s);
      };
      tick();
      root.__plbfTimer = setInterval(tick, 1000);
    }

    // Filter chips
    var chips = root.querySelectorAll('button[data-tab]');
    var grid = root.querySelector('[data-plbf-grid]');
    var hasAll = grid && grid.dataset.hasAll === '1';
    var cards = root.querySelectorAll('article.plbf-pick');
    chips.forEach(function (b) {
      b.addEventListener('click', function () {
        chips.forEach(function (x) {
          var on = x === b;
          x.classList.toggle('plbf-on', on);
          x.setAttribute('aria-pressed', on);
        });
        var tab = b.dataset.tab;
        cards.forEach(function (a) {
          var show = tab === '__all'
            ? (hasAll ? a.dataset.tab === '__all' : !a.hasAttribute('data-dup'))
            : a.dataset.tab === tab;
          a.hidden = !show;
        });
        if (grid) grid.scrollTo({ left: 0, behavior: 'smooth' });
      });
    });

    // Add to cart
    var pill = root.querySelector('[data-plbf-pill]');
    var countEl = root.querySelector('[data-plbf-count]');
    var after = root.dataset.afterAdd || 'stay';
    var cartUrl = root.dataset.cartUrl || '/cart';
    var addUrl = (root.dataset.cartAdd || '/cart/add') + '.js';
    var showCount = function (n) {
      if (!pill) return;
      countEl.textContent = n;
      pill.hidden = !(n > 0);
    };
    var refreshCount = function () {
      return fetch(cartUrl + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { showCount(c.item_count); })
        .catch(function () {});
    };
    if (pill) refreshCount();

    root.querySelectorAll('form[data-plbf-atc]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('button[type="submit"]');
        if (!btn || btn.disabled) return;
        var label = btn.dataset.label || btn.textContent;
        btn.disabled = true;
        btn.classList.add('plbf-busy');
        btn.textContent = 'Adding…';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(form.elements.id.value), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () {
            if (after === 'cart') { window.location.href = cartUrl; return; }
            if (after === 'checkout') { window.location.href = '/checkout'; return; }
            btn.textContent = 'Added ✓';
            btn.classList.remove('plbf-busy');
            btn.classList.add('plbf-added');
            refreshCount();
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              btn.textContent = label;
              btn.classList.remove('plbf-added');
              btn.disabled = false;
            }, 2200);
          })
          .catch(function (err) {
            btn.textContent = (err && err.description) ? err.description : 'Could not add';
            btn.classList.remove('plbf-busy');
            setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2600);
          });
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-plbf]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector('[data-plbf]');
    if (r && r.__plbfTimer) clearInterval(r.__plbfTimer);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
